import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VContainer,[_c(VLayout,{attrs:{"wrap":""}},[_c(VDataTable,{staticClass:"elevation-2",attrs:{"headers":_vm.headers,"items":_vm.results,"items-per-page":15,"loading":_vm.wait,"item-key":"icon","loading-text":"Waiting....maybe on you...","single-select":""},on:{"click:row":_vm.pop},scopedSlots:_vm._u([{key:"item.image",fn:function({ item }){return [_c(VAvatar,[_c(VImg,{attrs:{"src":item.image}})],1)]}}]),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }